import { render, staticRenderFns } from "./ActChildQuestions.vue?vue&type=template&id=cfe0e976&"
import script from "./ActChildQuestions.vue?vue&type=script&lang=js&"
export * from "./ActChildQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports